// TODO - remove lint disable when editing this file
/* eslint-disable */
import { size, isEmpty, keys, set } from 'lodash'

export default (story, websites) => {
  const storyWithDefaultWebsite = Object.assign({}, story)

  // Set default if there is only one website
  if (isEmpty(storyWithDefaultWebsite.websites) && size(websites) === 1) {
    const websiteId = keys(websites)[0]
    set(storyWithDefaultWebsite, `websites.${websiteId}`, {})
    set(storyWithDefaultWebsite, 'canonical_website', websiteId)
  }

  return storyWithDefaultWebsite
}
